import { render, staticRenderFns } from "./CoursewareEmptyElementBox.vue?vue&type=template&id=10cb18c4&"
import script from "./CoursewareEmptyElementBox.vue?vue&type=script&lang=js&"
export * from "./CoursewareEmptyElementBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports